import React, { createContext, useContext, useMemo, useState } from 'react';
import { lightTheme, darkTheme } from './theme';

const ThemeContext = createContext();
const DEFAULT_TEXT_SIZE = 16;

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [textSize, setTextSize] = useState(DEFAULT_TEXT_SIZE);

  const theme = useMemo(() => (isDarkMode ? darkTheme : lightTheme), [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode((prev) => !prev);
  };

  React.useEffect(() => {
    const root = document.documentElement;
    Object.entries(theme).forEach(([key, value]) => {
      try {
        const varName = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
        root.style.setProperty(varName, value);
      } catch (e) {
        // ignore
      }
    });
    root.style.setProperty('--card-bg', theme.surface);
    root.style.setProperty('--page-bg', theme.background);
    root.style.setProperty('--card-text', theme.text);
    root.style.setProperty('--primary', theme.primary);
    root.style.setProperty('--border', theme.border);
    root.style.setProperty('--error', theme.error);
    root.style.setProperty('--muted', theme.muted);
  }, [theme]);
  React.useEffect(() => {
    document.documentElement.style.setProperty('--app-font-size', `${textSize}px`);
  }, [textSize]);

  return (
    <ThemeContext.Provider value={{ theme, isDarkMode, toggleTheme, textSize, setTextSize }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
